import { Card, CardBody, CardHeader } from '@chakra-ui/react'
import { ISharedDiagnostic } from '../../../types/diagnostics'
import WhiteBoardImageViewer from './WhiteBoardImageViewer'
import HeaderWhiteBoardCard from './HeaderWhiteBoardCard'
import { IDiagnosticImage } from '../../../types/diagnostic-image'

interface WhiteBoardCardProps {
  sharedDiagnostic: ISharedDiagnostic
  onOpen: () => void
  diagnosticImages: IDiagnosticImage[]
  refetchDiagnosticImages: () => void
}

const WhiteBoardCard = ({
  sharedDiagnostic,
  onOpen,
  diagnosticImages,
  refetchDiagnosticImages,
}: WhiteBoardCardProps) => {
  return (
    <Card
      fontFamily={'Poppins'}
      w={'100%'}
      px={6}
      py={6}
      maxW="100%"
      overflow="hidden"
      borderRadius={'2xl'}
      boxShadow="2xl"
      bg="white"
      borderWidth="1px"
      borderColor="gray.100"
      position="relative"
      transition="all 0.3s"
      _hover={{
        boxShadow: '0 20px 40px rgba(102, 126, 234, 0.15)',
        transform: 'translateY(-2px)',
      }}
    >
      <CardHeader pb={6}>
        <HeaderWhiteBoardCard
          sharedDiagnostic={sharedDiagnostic}
          onOpen={onOpen}
        />
      </CardHeader>
      <CardBody pt={0}>
        <WhiteBoardImageViewer
          diagnosticImages={diagnosticImages ?? []}
          refetchDiagnosticImages={refetchDiagnosticImages}
        />
      </CardBody>
    </Card>
  )
}

export default WhiteBoardCard
